"use strict";

define('libs/cf.convert',['underscore', 'moment'], function (_, moment) {
  return {
    convertResponse: function convertResponse(resp) {
      var columns = _.map(resp.COLUMNS, function (colName) {
          return String(colName);
        }),
        itemObject = null,
        dataObjects = [],
        data = resp.DATA || [];
      for (var j = 0, columnLen = data.length, itemData; j < columnLen; j++) {
        itemData = data[j];
        itemObject = {};
        for (var i = 0, len = columns.length, columnName; i < len; i++) {
          columnName = columns[i];
          itemObject[columnName] = itemData[i];
          if (columnName.slice(-4) == 'DATE') {
            itemObject[columnName] = +moment(itemData[i], 'MMMM, DD YYYY HH:mm:ss');
          }
        }
        dataObjects.push(itemObject);
        itemObject = null;
      }
      return dataObjects;
    }
  };
});

